import { type BoxProps, VStack } from '@chakra-ui/react';
import { MDXRemote, type MDXRemoteSerializeResult } from 'next-mdx-remote';
import { FC } from 'react';
import components from './components';

interface MDXcontainerProps extends BoxProps {
  source: MDXRemoteSerializeResult;
}

const MDXcontainer: FC<MDXcontainerProps> = ({ source, ...props }) => (
  <VStack
    alignItems='start'
    {...props}
  >
    <MDXRemote
      components={components}
      {...source}
    />
  </VStack>
);

export default MDXcontainer;
